export const environment = {
  production: true,
  _auth_service: 'https://auth.nlf.no/auth',
  _logout_service: 'https://auth.nlf.no/logout',
  _client_id: '8f89f8b38ad5b6036c6a4b241a47ad68',
  _scope: 'read',
  _shebang: 0,
  _response_type: 'access_token',
  _name: 'prod',
  _top_level_name: 'app',
  _e5x_submission: true
};
